"use client";
import n, { useState as d } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import k from "./index.es73.js";
import i from "./index.es59.js";
import y from "./index.es17.js";
const f = i.div`
  .bl-accordion:not(.bl-accordion--is-closed) .bl-accordion__content,
  .bl-info-box {
    overflow: visible;
    display: block;
  }
`, u = i.div`
  text-align: right;
  a {
    display: inline-block;
  }
`, D = ({
  contextKey: c,
  accordionsData: t,
  initiallyOpen: r
}) => {
  const [o, l] = d(
    new Set(r)
  ), a = () => Object.keys(t).every((e) => o.has(e)), m = a() ? "Lukk Alle" : "Åpne alle", s = (e) => {
    e.preventDefault(), a() ? l(/* @__PURE__ */ new Set([])) : l(new Set(Object.keys(t)));
  }, p = (e) => {
    o.has(e) ? o.delete(e) : o.add(e), l(new Set(o.values()));
  }, b = Object.keys(t).length > 1;
  return /* @__PURE__ */ n.createElement(f, { className: "bl-container bl-container--small bl-m-b-4" }, b && /* @__PURE__ */ n.createElement(u, null, /* @__PURE__ */ n.createElement("a", { href: "#", className: "bl-link bl-m-y-2", onClick: s }, m)), Object.keys(t).map((e) => /* @__PURE__ */ n.createElement(
    k,
    {
      contentId: e,
      key: e,
      onClick: () => p(e),
      isOpen: o.has(e),
      header: e
    },
    /* @__PURE__ */ n.createElement(
      y,
      {
        keyContext: `block-accordion-${c}-${e}`,
        content: t[e].content,
        tooltips: t[e].tooltips
      }
    )
  )));
};
export {
  D as default
};
//# sourceMappingURL=index.es30.js.map
